import {ChangeDetectorRef, Component, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractNumericInput} from "../abstract-numeric-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIHeaderNumericInputComponent),
            multi: true
        }
    ],
    selector: "fui-header-numeric-input",
    styleUrls: ["./header-numeric-input.component.scss"],
    templateUrl: "./header-numeric-input.component.html",
    standalone: false
})
export class FUIHeaderNumericInputComponent extends FUIAbstractNumericInput {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }
}
